import { useMutation, useQuery } from "@tanstack/react-query";
import { backendApi } from "@/services/api.service.ts";

export enum ShowType {
  SCHEDULED = "scheduled",
  ALL_TIME = "all_time",
}

export enum BannerStatus {
  DRAFT = "draft",
  SHOWING = "showing",
}

export type Banner = {
  id: string;
  name?: string;
  desktopUrl?: string;
  mobileUrl?: string;
  showType?: ShowType;
  isDisplay?: boolean;
  status?: BannerStatus;
  startDate?: string; // Required if show_type is SCHEDULED
  endDate?: string; // Required if show_type is SCHEDULED
  orderNumber?: number;
  createdAt?: string;
  updatedAt?: string;
};

type PaginationRequest = {
  page?: number;
  pageSize?: number;
  name?: string;
  order?: string;
  sort?: string;
  filter?: string;
  searchKey?: string;
  searchValue?: string;
};

export const useGetAllBanners = (pagination: PaginationRequest) => {
  const config = { withCredentials: true, params: pagination };
  return useQuery({
    queryKey: ["get-all-banners", pagination], // Ensures caching is based on pagination
    queryFn: () => backendApi.get("/banners", config),
    retry: false,
    enabled: true,
    staleTime: 0,
  });
};

export const useUpdateBanners = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (data: any) => backendApi.put(`/admin/banners`, data, config),
  });
};

export const useCreateBanner = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (data: any) => backendApi.post(`/admin/banners`, data, config),
  });
};

export const useDeleteBanner = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (id: string) => backendApi.delete(`/admin/banners/${id}`, config),
  });
};